<template>
    <div>
        <headerNavbar title="新增人员信息" />
        <profileEdit />
    </div>
</template>

<style scoped>

</style>

<script>
    import profileEdit from '@/components/profileEdit';
    import headerNavbar from '@/views/components/headerNavbar';
    export default {
        components: {
            profileEdit,
            headerNavbar
        },
        data() {
            return {

            }
        },
        mounted() {
            this.$Dialog.alert({
                message: '为确保能正常为您提供线上预约和查询报告服务，请务必输入正确的个人信息。'
            }).then(() => {

            });
        },
    }
</script>